export default function TagBadge({ tag }) {
  const bg = tag.color || '#6c757d';
  const isLight = isLightColor(bg);
  return (
    <span
      className="badge me-1"
      style={{ backgroundColor: bg, color: isLight ? '#000' : '#fff' }}
    >
      {tag.name}
    </span>
  );
}

function isLightColor(hex) {
  const c = hex.replace('#', '');
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 128;
}
